<script>
    import { api_host, subdomain_manager, bpm_domain, all_users_store, price_setting_store, company_details_store,
        user_store, user_info_store, page_setting_store
    } from "../../stores.js";
    import { init_data, get_user_info } from '../../init.js';
    import { state_codes } from '../../globals.js';
    import { onMount } from 'svelte';
    import Header from "../header.svelte";
    import { pop, push, querystring } from 'svelte-spa-router';
    import IFTAInput from "../../utils/iftainput.svelte";
    import { toast_message } from '../../utils/toast_message.js';
    import { getToken, doAPIPost, doFetch, doAddressSearch } from '../../utils/Fetching.js';
    import Swal from "sweetalert2";
    import Itemselector from "../../utils/itemselector.svelte";
    import { getFullState, formatDate, handle_not_subscribed, deepCopy } from "../../utils/format.js";
    import CreditCardEntry from "../../utils/creditcardentry.svelte";
    import { getTax, get_main_service_price, get_extra_service_prices, description_validation_func, rate_validation_func, quantity_validation_func, price_validation_func, convert_tax_rates } from '../../utils/tax.js';

    const { auth_type, auth_token, domain_code } = getToken();
    
    let content_title = "Create Job";
    let crew_selection_error_msg = 'Crew is required';
    let is_crew_check_first = true;
    let is_busy = true;
    let price_calculator = false;
    let show_cc_entry = false;
    let today = new Date();
    today.setDate(today.getDate() + 1);
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0');
    let yyyy = today.getFullYear();
    today = mm + '-' + dd + '-' + yyyy.toString().substring(2);
    let crew_items = [];
    let uid = '';
    let qid = 0;
    let my_domain = '';
    let booking_link = '';
    let company_state = 'Arizona';
    let myself = {};
    let profile = {};
    let price_setting = {};
    let config_lawn_settings = [];
    let config_service_settings = [];
    let config_service_type_settings = [];
    let photos = [], fileinput;
    let tax_rate_options = [];
    let tax_rates = [];
    let extra_service_price_list = [];
    let extra_contractor_price_list = [];

    const onFileSelected = (e) => {
        const files = Array.from(e.target.files);
        files.forEach(file => {
            console.log('file', file);

            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = e => {
                let image = new Image();
                image.src = e.target.result;
                image.onload = () => {

                    let canvas = document.createElement('canvas');
                    let context = canvas.getContext('2d');

                    // Set the canvas dimensions to the desired downscaled size
                    let downscaledWidth = 400; // Adjust to your desired width
                    let downscaledHeight = (image.height / image.width) * downscaledWidth;
                    canvas.width = downscaledWidth;
                    canvas.height = downscaledHeight;

                    // Draw the image onto the canvas with the downscaled size
                    context.drawImage(image, 0, 0, downscaledWidth, downscaledHeight);

                    // Convert the downscaled image on the canvas to a base64 data URL with reduced quality
                    let downscaledDataURL = canvas.toDataURL('image/jpeg', 0.8); // Adjust quality as needed

                    photos = [
                        ...photos, 
                        {
                            filename: file.name,
                            body: downscaledDataURL
                        }
                    ];
                    console.log('downgraded', photos);
                }
            };
        });
    };

    const onFileRemoved = async (index) => {
        const result = await Swal.fire({
            title: "Are you sure you want to delete this photo?",
            text: '',
            buttonsStyling: true,
            confirmButtonClass: "button",
            confirmButtonText: 'Ok',
            cancelButtonText: "Cancel",
            showCancelButton: true,
            icon: "warning"
        });
        if (!result.isConfirmed) return;

        const photo = photos[index];
        if (photo.uploaded) {
            photo.deleted = true;
        } else {
            photos.splice(index);
        }
        photos = photos;
    };

    const upload_images = async (photos, tag) => {
        const urls = [];
        for (let i = 0; i < photos.length; i++) {
            const photo = photos[i];
            if (photo.uploaded) {
                if (!photo.deleted) urls.push(photo.body);
            } else {
                const payload = {
                    tag,
                    image: photo.body,
                    filename: photo.filename
                };
                const { auth_type, auth_token, domain_code } = getToken();
                const res = await doFetch(
                    `${api_host}/api/upload/image`,
                    'POST',
                    payload,
                    { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
                );
                if (res.url) urls.push(res.url);
            }
        }
        return urls;
    };

    user_store.subscribe(value => {
        myself = value;
    });
    subdomain_manager.subscribe(value => {
        my_domain = value + '.' + bpm_domain;
    });
    
    $: is_employee_exists = crew_items.filter(item => item.role === 'employee' && item.a).length > 0;

    onMount(async () => {
        init_data('pages');

        fields[0].value = "";
        fields[1].value = "";
        fields[2].value = "";
        fields[3].value = "";
        fields[4].value = "";
        fields[5].value = "";
        fields[6].value = "";
        fields[7].value = "";
        fields[8].value = "";
        fields[11].value = 1;
        const params = new URLSearchParams($querystring);
        if (params.has("uid")) {
            uid = params.get("uid");
            get_user_info(uid);
        } else if (params.has("qid")) {
            qid = parseInt(params.get("qid"));
            const res = await doFetch(
                `${api_host}/api/quote/get/${qid}`,
                'GET',
                null,
                { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
            );
            if (res.status) {
                const quote = res.quote;
                fields[0].value = quote.address;
                fields[1].value = quote.city;
                fields[2].value = getFullState(quote.state);
                fields[3].value = quote.zipcode;
                fields[4].value = quote.first_name;
                fields[5].value = quote.last_name;
                fields[6].value = quote.email;
                fields[7].value = quote.home_phone;
                fields[8].value = quote.mobile_phone;
                fields[9].value = quote.paymethod;
                fields[13].value = quote.service_type;
                // fields[14].value = quote.service_date;
                fields[15].value = quote.time_preference;
                fields[16].value = quote.service_frequency;
                if (quote.service_frequency == 'One-Time') { fields[27].hidden = true; }
                fields[17].value = quote.lawn;
                fields[18].value = quote.last_service;
                fields[19].value = quote.back_yard_entry;
                fields[20].value = quote.additional_comments;
                fields[21].value = quote.internal_comments;
                fields[27].value = quote.next_service_price;
                photos = quote.photos?.map(url => ({
                    uploaded: true,
                    deleted: false,
                    body: url
                })) ?? [];
                if (quote.service_type !== "Yard/Lawn Service") {
                    fields[17].hidden = true;
                    fields[18].hidden = true;
                }
                tax_rate_options = res.tax_rate_options;

                console.log(quote);
                if (quote.service_prices.length > 0) {
                    const main_service_price = get_main_service_price(quote.service_prices, tax_rate_options);
                    fields[10].value = main_service_price.rate;
                    fields[11].value = main_service_price.quantity;
                    tax_rates = main_service_price.tax_rates;
                } else {
                    fields[10].value = quote.service_price;
                    fields[11].value = 1;
                }

                extra_service_price_list = get_extra_service_prices(quote.service_prices, tax_rate_options);
                extra_contractor_price_list = [];
                set_total_service_price();

                console.log('quote tax_rates', tax_rates);
            }
            else { toast_message(false, 'Fetching quote failed', 3000); }
        } else { }

        all_users_store.subscribe(value => {
            if (Object.keys(value).length) {
                const crews = value.filter(user => user.role === 'contractor' || user.role === 'employee' || user.role === 'landscaper');
                for (let i = 0; i < crews.length; i ++) {
                    const crew = crews[i];
                    if (crew.is_active) {
                        crew_items.push({
                            t: `${crew.first_name} ${crew.last_name}` + (crew.role === 'landscaper' ? ' (Owner)' : ''),
                            a: false,
                            uid: crew.id,
                            role: crew.role !== 'landscaper' ? crew.role : 'employee',
                            r_role: crew.role,
                            disabled: false,
                            hours: 0,
                            notes: '',
                        });
                    }
                }
            }
        });

        price_setting_store.subscribe(value => {
            price_setting = value;
            if (Object.keys(value).length) {
                fields[23].value = value.contractor_margin;
                set_total_service_price();
            }
        });
        
    });

    let cc_number, cc_name, cc_cvc, cc_expiry;
    let is_cc_number_valid, is_cc_cvc_valid, is_cc_expiry_valid;

    const set_total_service_price = () => {
        fields[12].value = parseFloat(fields[10].value || 0) * parseFloat(fields[11].value || 0);

        let extra_service_price = 0;
        let extra_service_tax = 0;
        extra_service_price_list.forEach(item => {
            extra_service_price += item.rate * item.quantity;
            extra_service_tax += getTax(item.rate * item.quantity, item.tax_rates);
        });
        fields[28].value = (parseFloat(fields[12].value || 0) + extra_service_price).toFixed(2);
        
        let subtotal = parseFloat(fields[28].value || 0);
        let service_tax = getTax(fields[12].value, tax_rates) + extra_service_tax;
        
        fields[29].value = service_tax.toFixed(2);
        fields[30].value = (subtotal + service_tax).toFixed(2);

        // contractor prices
        fields[24].value = (parseFloat(fields[12].value || 0) * parseFloat(fields[23].value || 0)).toFixed(2);

        let extra_contractor_price = 0;
        extra_contractor_price_list.forEach(item => {
            extra_contractor_price += parseFloat(item.price || 0);
        });
        fields[25].value = extra_contractor_price;
        fields[26].value = parseFloat(fields[24].value || 0) + parseFloat(fields[25].value || 0);
    };

    let fields = [
        {
            "index": 0,
            "group": "contact1",
            "type": "text",
            "label": "Address",
            "value": "",
            "placeholder": "eg. 123 My Street",
            "name": "job[address]",
            "validation_function": () => {
                if (fields[0].value.length) {
                    fields[0]['show_error'] = false;
                    return true;
                } else {
                    fields[0]['show_error'] = true;
                    fields[0]['error_text'] = 'Address is required';
                    return false;
                }
            }
        }, {
            "index": 1,
            "group": "contact1",
            "type": "text",
            "label": "City",
            "value": "",
            "placeholder": "eg. Phoenix",
            "name": "job[city]",
            "validation_function": () => {
                if (fields[1].value.length) {
                    fields[1]['show_error'] = false;
                    return true;
                } else {
                    fields[1]['show_error'] = true;
                    fields[1]['error_text'] = 'City is required';
                    return false;
                }
            }
        }, {
            "index": 2,
            "group": "contact1",
            "type": "select",
            "label": "State",
            "value": "Arizona",
            "select_options": Object.keys(state_codes),
            "name": "job[state]",
            "validation_function": () => {
                if (fields[2].value.length) {
                    fields[2]['show_error'] = false;
                    return true;
                } else {
                    fields[2]['show_error'] = true;
                    fields[2]['error_text'] = 'Invalid State';
                    return false;
                }
            }
        }, {
            "index": 3,
            "group": "contact1",
            "type": "text",
            "label": "Zip Code",
            "value": "",
            "placeholder": "Optional (eg. 85001)",
            "name": "job[zipcode]",
            "validation_function": () => {
                const zipformat = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
                if (fields[3].value.length == 0) return true;
                if (fields[3].value.match(zipformat)) {
                    fields[3]['show_error'] = false;
                    return true;
                } else {
                    fields[3]['show_error'] = true;
                    fields[3]['error_text'] = 'Invalid zipcode';
                    return false;
                }
            }
        }, {
            "index": 4,
            "group": "contact2",
            "type": "text",
            "label": "First Name",
            "value": "",
            "placeholder": "eg. Alfred",
            "name": "job[first_name]",
            "validation_function": (is_booking) => {
                if (fields[4].value.length >= (is_booking ? 0 : 1)) {
                    fields[4]['show_error'] = false;
                    return true;
                } else {
                    fields[4]['show_error'] = true;
                    fields[4]['error_text'] = 'First Name is required';
                    return false;
                }
            }
        }, {
            "index": 5,
            "group": "contact2",
            "type": "text",
            "label": "Last Name",
            "value": "",
            "placeholder": "eg. Smith",
            "name": "job[last_name]",
            "validation_function": (is_booking) => {
                if (fields[5].value.length >= (is_booking ? 0 : 1)) {
                    fields[5]['show_error'] = false;
                    return true;
                } else {
                    fields[5]['show_error'] = true;
                    fields[5]['error_text'] = 'Last Name is required';
                    return false;
                }
            }
        }, {
            "index": 6,
            "group": "contact2",
            "type": "text",
            "label": "Email",
            "value": "",
            "placeholder": "eg. asmith@google.com",
            "name": "job[email]",
            "validation_function": (is_booking) => {
                const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
                if (fields[6].value.match(mailformat) || (is_booking ? fields[6].value.length === 0 : false)) {
                    fields[6]['show_error'] = false;
                    return true;
                } else {
                    fields[6]['show_error'] = true;
                    fields[6]['error_text'] = 'Invalid email';
                    return false;
                }
            }
        }, {
            "index": 7,
            "group": "contact3",
            "type": "text",
            "label": "Home Phone",
            "value": "",
            "placeholder": "eg. 000-000-0000",
            "name": "job[home_phone]",
            'change_function': (evt) => {
                var x = evt.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                evt.target.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
            },
            "validation_function": (is_booking) => {
                const phoneformat = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
                if (fields[7].value.match(phoneformat) || (is_booking ? fields[7].value.length === 0 : false)) {
                    fields[7]['show_error'] = false;
                    return true;
                } else {
                    fields[7]['show_error'] = true;
                    fields[7]['error_text'] = 'Invalid phone number';
                    return false;
                }
            }
        }, {
            "index": 8,
            "group": "contact3",
            "type": "text",
            "label": "Mobile Phone",
            "value": "",
            "placeholder": "eg. 000-000-0000",
            "name": "job[mobile_phone]",
            'change_function': (evt) => {
                var x = evt.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                evt.target.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
            },
            "validation_function": (is_booking) => {
                const phoneformat = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
                if (fields[8].value.match(phoneformat) || (is_booking ? fields[8].value.length === 0 : false)) {
                    fields[8]['show_error'] = false;
                    return true;
                } else {
                    fields[8]['show_error'] = true;
                    fields[8]['error_text'] = 'Invalid phone number';
                    return false;
                }
            }
        }, {
            "index": 9,
            "group": "pricing0",
            "type": "select",
            "label": "Payment Method",
            "value": "Credit Card",
            "select_options": ['Credit Card', 'Cash', 'Check'],
            "name": "job[payment_method]",
            "validation_function": () => { return true; }
        }, {
            "index": 10,
            "group": "pricing1",
            "type": "text",
            "label": "Rate $",
            "value": 0,
            "placeholder": "eg. 0.00",
            "name": "quote[service_rate]",
            "change_function": (evt) => {
                fields[10].value = parseFloat(evt.target.value).toFixed(2);
                set_total_service_price();
                if (fields[10].value > 0) {
                    fields[10]['show_error'] = false;
                } else {
                    fields[10]['show_error'] = false;
                    fields[10]['error_text'] = 'Service Rate is required';
                }
            },
            "validation_function": () => {
                if (parseFloat(fields[10].value) >= 0) {
                    fields[10]['show_error'] = false;
                    return true;
                } else {
                    fields[10]['show_error'] = true;
                    fields[10]['error_text'] = 'Service Rate is required';
                    return false;
                }
            }
        }, {
            "index": 11,
            "group": "pricing1",
            "type": "text",
            "label": "Quantity",
            "value": 0,
            "placeholder": "eg. 0.00",
            "name": "quote[service_quantity]",
            "change_function": (evt) => {
                fields[11].value = parseFloat(evt.target.value).toFixed(2);
                set_total_service_price();
                if (fields[11].value > 0) {
                    fields[11]['show_error'] = false;
                } else {
                    fields[11]['show_error'] = false;
                    fields[11]['error_text'] = 'Service Rate is required';
                }
            },
            "validation_function": () => {
                if (parseFloat(fields[11].value) > 0) {
                    fields[11]['show_error'] = false;
                    return true;
                } else {
                    fields[11]['show_error'] = true;
                    fields[11]['error_text'] = 'Service Quantity is required';
                    return false;
                }
            }
        }, {
            "index": 12,
            "group": "pricing1",
            "type": "text",
            "label": "Service Price $",
            "value": 0,
            "placeholder": "eg. 0.00",
            "name": "quote[service_price]",
            "validation_function": () => { return true; },
            "disabled": true,
        }, {
            "index": 13,
            "group": "pricing0",
            "type": "select",
            "label": "Service Type",
            "value": "Yard/Lawn Service",
            "style": "min-width: 200px;",
            "change_function": (e) => {
                const new_val = e.target.value;
                if(new_val !== "Yard/Lawn Service") {
                    fields[17].hidden = true;
                    fields[18].hidden = true;
                }else{
                    fields[17].hidden = false;
                    fields[18].hidden = false;
                }
            },
            "select_options": [],
            "name": "job[service_type]",
            "validation_function": () => { return true; }
        }, {
            "index": 14,
            "group": "service1",
            "type": "date",
            "label": "Service Date",
            "value": '',
            "name": "job[day_of_service]",
            "validation_function": () => {
                if (fields[14].value.length > 0) {
                    fields[14]['show_error'] = false;
                    return true;
                } else {
                    fields[14]['show_error'] = true;
                    fields[14]['error_text'] = 'Invalid Service Date';
                    return false;
                }
            }
        }, {
            "index": 15,
            "group": "service1",
            "type": "select",
            "label": "Time Preference",
            "value": "No Preference",
            "select_options": ['No Preference', 'Morning', 'Afternoon', '6AM', '7AM', '8AM', '9AM', '10AM', '11AM', '12PM', '1PM', '2PM', '3PM', '4PM', '5PM', '6PM' ],
            "name": "job[time_preference]",
            "validation_function": () => { return true; }
        }, {
            "index": 16,
            "group": "service1",
            "type": "select",
            "label": "Service Frequency",
            "value": '',
            "select_options": [],
            "name": "job[service_frequency]",
            "change_function": (evt) => {
                if (evt.target.value) {
                    fields[16]['show_error'] = false;
                } else {
                    fields[16]['show_error'] = true;
                    fields[16]['error_text'] = 'Service Frequency is required';
                }
                if (evt.target.value === 'One-Time') {
                    fields[27].hidden = true;
                } else {
                    fields[27].hidden = false;
                }
            },
            "validation_function": () => {
                if (fields[16].value.length > 0) {
                    fields[16]['show_error'] = false;
                    return true;
                } else {
                    fields[16]['show_error'] = true;
                    fields[16]['error_text'] = 'Service Frequency is required';
                    return false;
                }
            }
        }, {
            "index": 17,
            "group": "service2",
            "type": "select",
            "label": "Lawn",
            "value": "",
            "select_options": [],
            "name": "job[lawn]",
            "validation_function": () => { return true; }
        }, {
            "index": 18,
            "group": "service2",
            "type": "select",
            "label": "Last Cleanup?",
            "value": "Less than 2 weeks ago",
            "select_options": ['Less than 2 weeks ago', '2 to 4 weeks ago', '1 to 2 months ago', '3 months or more'],
            "name": "job[last_cleanup]",
            "validation_function": () => { return true; }
        }, {
            "index": 19,
            "group": "service2",
            "type": "select",
            "label": "Back Yard Entry Instructions",
            "value": "Other",
            "select_options": ['Already Open', 'Ring Door Bell', 'Not Required', 'Other'],
            "name": "job[back_yard_entry]",
            "validation_function": () => { return true; }
        }, {
            "index": 20,
            "group": "comments",
            "type": "textarea",
            "label": "Additional Comments",
            "value": "",
            "placeholder": "... any additional comments for this job.",
            "name": "job[comments]",
            "maxlength": 5000,
            "validation_function": () => { return true; }
        }, {
            "index": 21,
            "group": "comments",
            "type": "textarea",
            "label": "Internal Comments",
            "value": "",
            "placeholder": "... any internal comments for this job.",
            "name": "job[comments]",
            "maxlength": 5000,
            "validation_function": () => { return true; }
        }, {
            "index": 22,
            "group": "crew1_temp",
            "type": "select",
            "label": "Crew Names",
            "value": "-- No crew --",
            "select_options": ['-- No crew --'],
            "name": "job[crew_member]",
            "validation_function": () => { return true; }
        }, {
            "index": 23,
            "group": "crew1",
            "type": "text",
            "label": "Contractor Margin",
            "value": "",
            "name": "job[contractor_margin]",
            "change_function": (evt) => {
                fields[23].value = parseFloat(evt.target.value).toFixed(6);
                if (parseFloat(fields[12].value) >= 0) {
                    fields[24].value = (parseFloat(fields[12].value || 0) * parseFloat(evt.target.value || 0)).toFixed(2);
                    fields[26].value = parseFloat(fields[24].value || 0) + parseFloat(fields[25].value);
                }
            },
            "validation_function": () => {
                if (parseFloat(fields[23].value) >= 0) {
                    fields[23]['show_error'] = false;
                    return true;
                } else {
                    fields[23]['show_error'] = true;
                    fields[23]['error_text'] = 'Contractor Margin is required';
                    return false;
                }
            }
        }, {
            "index": 24,
            "group": "crew1",
            "type": "text",
            "label": "Contractor Price $",
            "value": 0,
            "name": "job[contractor_price]",
            "change_function": (evt) => {
                fields[24].value = parseFloat(evt.target.value).toFixed(2);
                if (parseFloat(fields[12].value) > 0) {
                    fields[23].value = (parseFloat(evt.target.value || 0) / parseFloat(fields[12].value || 0)).toFixed(6);
                    fields[26].value = (parseFloat(evt.target.value || 0) + parseFloat(fields[25].value)).toFixed(2);
                }
            },
            "validation_function": () => {
                if (is_employee_exists) { return true; }
                if (parseFloat(fields[24].value) >= 0) {
                    fields[24]['show_error'] = false;
                    return true;
                } else {
                    fields[24]['show_error'] = true;
                    fields[24]['error_text'] = 'Contract Price is required';
                    return false;
                }
            }
        }, {
            "index": 25,
            "group": "crew1",
            "type": "text",
            "label": "Extra Contractor Price $",
            "value": 0,
            "name": "job[extra_contractor_price]",
            "validation_function": () => true,
            "disabled": true,
        }, {
            "index": 26,
            "group": "crew1",
            "type": "text",
            "label": "Total Contractor Price $",
            "value": 0,
            "name": "job[total_contractor_price]",
            "validation_function": () => true,
            "disabled": true,
        }, {
            "index": 27,
            "group": "pricing1",
            "type": "text",
            "label": "Next Service Price $",
            "value": 0,
            "placeholder": "eg. 0.00",
            "name": "job[original_price]",
            "change_function": (evt) => {
                fields[27].value = parseFloat(evt.target.value).toFixed(2);
            },
            "validation_function": (is_booking, is_price_calculator) => {
                if (is_price_calculator || fields[16].value === 'One-Time') {
                    fields[27]['show_error'] = false;
                    return true;
                }
                if (parseFloat(fields[27].value) > 0) {
                    fields[27]['show_error'] = false;
                    return true;
                } else {
                    fields[27]['show_error'] = true;
                    fields[27]['error_text'] = 'Invalid Next Service Price';
                    return false;
                }
            }
        }, {
            "index": 28,
            "group": "pricing2",
            "type": "text",
            "label": "Subtotal Price $",
            "value": 0,
            "placeholder": "eg. 0.00",
            "name": "quote[subtotal_price]",
            "hidden": false,
            "validation_function": () => true,
            "disabled": true
        }, {
            "index": 29,
            "group": "pricing2",
            "type": "text",
            "label": "Tax $",
            "value": 0,
            "placeholder": "eg. 0.00",
            "name": "quote[tax_price]",
            "hidden": false,
            "validation_function": () => true,
            "disabled": true
        }, {
            "index": 30,
            "group": "pricing2",
            "type": "text",
            "label": "Total Service Price $",
            "value": 0,
            "placeholder": "eg. 0.00",
            "name": "quote[total_service_price]",
            "hidden": false,
            "validation_function": () => {
                if (parseFloat(fields[30].value) >= 0) {
                    fields[30]['show_error'] = false;
                    return true;
                } else {
                    fields[30]['show_error'] = true;
                    fields[30]['error_text'] = 'Total Service Price is required';
                    return false;
                }
            },
            "disabled": true
        },
    ];

    company_details_store.subscribe(value => {
        company_state = value['state'] || 'Arizona';
        fields[2].value = company_state;
        is_busy = false;

        if (!value.tax_rates) return;
        if (!qid) {
            tax_rate_options = value.tax_rates;
            tax_rates = convert_tax_rates([], tax_rate_options);
            console.log('tax_rates', tax_rates);
        }     
    });

    page_setting_store.subscribe(page_setting => {
        if(page_setting.lawn_options == undefined) return;
        config_lawn_settings = Object.keys(page_setting.lawn_options);
        config_service_settings = Object.keys(page_setting.service_frequency_options);
        config_service_type_settings = Object.keys(page_setting.service_type_options).filter(key => page_setting.service_type_options[key]).sort((a, b) => page_setting.service_type_options[a] - page_setting.service_type_options[b]);

        config_service_settings.unshift('');
        const freequencies = ["Every 3 weeks", "Every 6 weeks", "Every 2 months"];
        freequencies.forEach(f => config_service_settings.push(f));

        fields[16].select_options = config_service_settings;
        fields[17].value = config_lawn_settings.length > 0 ? config_lawn_settings[0] : '';
        fields[17].select_options = config_lawn_settings;
        fields[13].select_options = config_service_type_settings;
    });

    const validateCC = () => {
        let is_valid = true;
        if (show_cc_entry) {
            is_valid = is_cc_number_valid && is_cc_expiry_valid && is_cc_cvc_valid;
        }
        return is_valid;
    }

    const validateForm = (job_or_book='job', is_price_calculator) => {
        let is_valid = true;
        fields.forEach(field => {
            if (!field.validation_function(job_or_book === 'book', is_price_calculator)) {
                is_valid = false;
            }
        });

        if (crew_items.filter(item => item.a).length === 0) {
            if (job_or_book === 'job') {
                is_valid = false;
                is_crew_check_first = false;
            }
        }

        if (!validateCC()) {
            is_valid = false;
        }

        extra_service_price_list.forEach(item => {
            if (!description_validation_func(item)) {
                console.log('validate error:', item);
                is_valid = false;
            }
            if (!rate_validation_func(item)) {
                console.log('validate error:', item);
                is_valid = false;
            }
            if (!quantity_validation_func(item)) {
                console.log('validate error:', item);
                is_valid = false;
            }
        });
        extra_service_price_list = extra_service_price_list;

        extra_contractor_price_list.forEach(item => {
            if (!description_validation_func(item)) {
                console.log('validate error:', item);
                is_valid = false;
            }
            if (!price_validation_func(item)) {
                console.log('validate error:', item);
                is_valid = false;
            }
        });
        extra_contractor_price_list = extra_contractor_price_list;

        return is_valid;
    };
    
    window.copyAddress = () => {
        navigator.clipboard.writeText(booking_link);
        toast_message(true, 'Booking Link Copied', 1000);
    }

    const create_job_or_book = async (job_or_book) => {
        if (!myself['is_subscribed']) {
            handle_not_subscribed(myself.is_authenticated, myself.is_domain_expired);
            return;
        }
        if (fields[12].value < 5) {
            alert('Apologies, but we\'re unable to process jobs with a value lower than $5.');
            return;
        }
        if(validateForm(job_or_book, job_or_book === 'job' ? false : price_calculator)) {
            is_busy = true;

            const uploadedUrls = await upload_images(photos, 'quote');

            const get_state_code = (state) => {
                return state_codes[state];
            };
            const service_prices = deepCopy(extra_service_price_list);
            service_prices.push({
                "description": "",
                "rate": fields[10].value,
                "quantity": fields[11].value,
                "tax_rates": tax_rates,
                "is_main": true
            });

            const payload = {
                "address": fields[0].value,
                "city": fields[1].value,
                "state": get_state_code(fields[2].value),
                "zipcode": fields[3].value,
                "service_date": formatDate(fields[14].value),
                "time_preference": fields[15].value,
                "lawn": fields[17].value,
                "service_frequency": fields[16].value,
                "service_type": fields[13].value,
                "last_service": fields[18].value,
                "back_yard_entry": fields[19].value,
                "first_name": fields[4].value,
                "last_name": fields[5].value,
                "full_name": `${fields[4].value} ${fields[5].value}`,
                "email": fields[6].value.toLowerCase(),
                "mobile_phone": fields[8].value,
                "home_phone": fields[7].value,
                "service_price": fields[12].value,
                "total_service_price": fields[30].value,
                "next_service_price": fields[27].value,
                "giftcard": '',
                "additional_comments": fields[20].value,
                "internal_comments": fields[21].value,
                "contractor_margin": fields[23].value,
                "contractor_price": is_employee_exists ? 0 : fields[24].value,
                "extra_contractor_price": is_employee_exists ? 0 : fields[25].value,
                "total_contractor_price": is_employee_exists ? 0 : fields[26].value,
                "paymethod": fields[9].value,
                "cc_name": cc_name || '',
                "cc_number": cc_number || '',
                "cc_cvc": cc_cvc || '',
                "cc_expiry": cc_expiry || '',
                "crews": crew_items.filter(item => item.a),
                "photos": uploadedUrls,
                service_prices,
                "extra_contractor_prices": is_employee_exists ? [] : extra_contractor_price_list,
            };
            if (qid) { payload['qid'] = qid; }
            if (uid) { payload['uid'] = uid; }

            if (job_or_book == 'job') {
                payload['is_manual'] = true;
                const turl = api_host + "/api/job/create_lj";
                const headers = { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' };
                let res = await doAPIPost(
                    turl,
                    "Booking your lawn service appointment...",
                    "Appoinment booked! Check your email for confirmation.",
                    payload,
                    headers,
                    3000
                );
                if (res) {
                    init_data('jobs');
                    init_data('users');
                    push('#/Jobs?filter=all');
                }
            } else {
                if (fields[16].value !== 'Weekly' && fields[16].value !== 'Bi-Weekly' && fields[16].value !== 'Monthly' && fields[16].value !== 'One-Time') {
                    toast_message(false, 'Service not valid (weekly, biweekly, monthly, one-time only)', 5000);
                    is_busy = false;
                    return;
                }
                const address_search_res = await doAddressSearch(api_host, `${payload['address']}, ${payload['city']}, ${payload['state']}`);
                if (address_search_res.st !== 'false') {
                    payload['address'] = address_search_res.data.address;
                    payload['city'] = address_search_res.data.city;
                    payload['state'] = address_search_res.data.state;
                    if (price_calculator) {
                        payload['building_stories'] = address_search_res.data.building_stories;
                        payload['latitude'] = address_search_res.data.latitude;
                        payload['longitude'] = address_search_res.data.longitude;
                        payload['lot_size'] = address_search_res.data.lot_size;
                    }
                } else {
                    payload['is_manual'] = true;
                    payload['building_stores'] = '';
                    payload['latitude'] = 200;
                    payload['longitude'] = 200;
                    payload['lot_size'] = 0;
                }
                payload['internal_comments'] = '';
                const res = await doFetch(
                    `${api_host}/api/job/create_bl`,
                    'POST',
                    { content: JSON.stringify(payload) },
                    { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
                );
                if (res.status) {
                    toast_message(true, res.msg, 3000);
                    booking_link = `https://${my_domain}/booking?blid=${res.booking_link_id}`;
                    const booking_link_html = `<span>
                        ${booking_link} 
                        <i class="fas fa-copy" style="cursor: pointer;" onclick="copyAddress()"></i>
                    </span>`;
                    Swal.fire({
                        title: "Booking link",
                        html: booking_link_html,
                        buttonsStyling: true,
                        confirmButtonClass: "button",
                        confirmButtonText: 'Ok',
                        cancelButtonText: "Cancel",
                        showCancelButton: true,
                        icon: "success"
                    }).then((e) => {
                        if (e.isConfirmed) {
                            window.open(booking_link, '_blank');
                        }
                    });
                } else {
                    toast_message(false, res.msg || 'Bad request', 3000);
                    is_busy = false;
                }
            }
            is_busy = false;
        } else {
            let msg = 'Missing or invalid info';
            if (!validateCC()) {
                msg += ' and card info';
            }
            toast_message(false, msg, 3000);
        }
    };

    user_info_store.subscribe(value => {
        if (value.profile) {
            profile = value.profile;
            fields[0].value = profile.address;
            fields[1].value = profile.city;
            fields[2].value = profile.state.length == 2 ? Object.keys(state_codes).find(item => state_codes[item] == profile.state) : profile.state;
            fields[3].value = profile.zipcode;
            fields[4].value = profile.first_name;
            fields[5].value = profile.last_name;
            fields[6].value = profile.email;
            fields[7].value = profile.home_phone;
            fields[8].value = profile.mobile_phone;
        }
    });
</script>

<Header bind:title={content_title} bind:is_busy={is_busy} />

<div class="contentholder">
    <div class="section contactinfo">
        <div class="sectiontitle"><i class="fas fa-user"></i> Contact Information</div>
        <div class="sectioninfo">
            <div class="ff formrow">
                {#each fields.filter((e)=>e.group === "contact1") as nf}
                <IFTAInput 
                    type={(nf.type !== undefined) ? nf.type : ""} 
                    label={(nf.label !== undefined) ? nf.label : ""} 
                    placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
                    helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
                    select_options={(nf.select_options !== undefined) ? nf.select_options : ""}
                    name={nf.name}
                    show_error={nf.show_error}
                    error_text={nf.error_text}
                    bind:value={nf.value}
                    bind:validation_function={nf.validation_function}
                    bind:extFuncs={nf.ext_funcs}
                />
                {/each}
            </div>

            <div class="ff formrow">
                {#each fields.filter((e)=>e.group === "contact2") as nf}
                <IFTAInput 
                    type={(nf.type !== undefined) ? nf.type : ""} 
                    label={(nf.label !== undefined) ? nf.label : ""} 
                    placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
                    helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
                    select_options={(nf.select_options !== undefined) ? nf.select_options : ""}
                    name={nf.name}
                    show_error={nf.show_error}
                    error_text={nf.error_text}
                    bind:value={nf.value}
                    bind:validation_function={nf.validation_function}
                    bind:extFuncs={nf.ext_funcs}
                />
                {/each}
            </div>

            <div class="ff formrow">
                {#each fields.filter((e)=>e.group === "contact3") as nf}
                <IFTAInput 
                    type={(nf.type !== undefined) ? nf.type : ""} 
                    label={(nf.label !== undefined) ? nf.label : ""} 
                    placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
                    helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
                    select_options={(nf.select_options !== undefined) ? nf.select_options : ""}
                    name={nf.name}
                    show_error={nf.show_error}
                    error_text={nf.error_text}
                    bind:value={nf.value}
                    bind:validation_function={nf.validation_function}
                    bind:change_function={nf.change_function}
                    bind:extFuncs={nf.ext_funcs}
                />
                {/each}
            </div>
        </div>
    </div>

    <div class="section pricinginfo">
        <div class="sectiontitle"><i class="fas fa-dollar-sign"></i> Pricing Information</div>
        <div class="sectioninfo">
            <div class="ff formrow">
                {#each fields.filter((e)=>e.group === "pricing0") as nf}
                <IFTAInput 
                    type={(nf.type !== undefined) ? nf.type : ""}
                    label={(nf.label !== undefined) ? nf.label : ""}
                    placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""}
                    helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""}
                    select_options={(nf.select_options !== undefined) ? nf.select_options : ""}
                    name={nf.name}
                    show_error={nf.show_error}
                    error_text={nf.error_text}
                    style={nf.style}
                    bind:value={nf.value}
                    bind:change_function={nf.change_function}
                    bind:validation_function={nf.validation_function}
                    bind:extFuncs={nf.ext_funcs}
                    bind:hidden={nf.hidden}
                />
                {/each}
                {#each fields.filter((e)=>e.group === "pricing1") as nf}
                <IFTAInput 
                    type={(nf.type !== undefined) ? nf.type : ""} 
                    label={(nf.label !== undefined) ? nf.label : ""} 
                    placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
                    helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
                    select_options={(nf.select_options !== undefined) ? nf.select_options : ""}
                    name={nf.name}
                    show_error={nf.show_error}
                    error_text={nf.error_text}
                    bind:change_function={nf.change_function}
                    bind:value={nf.value}
                    bind:hidden={nf.hidden}
                    bind:validation_function={nf.validation_function}
                    bind:extFuncs={nf.ext_funcs}
                    bind:disabled={nf.disabled}
                />
                {/each}
                <div class="mockgroupitem">
                    <Itemselector 
                        title="Tax Rates"
                        bind:items={tax_rates}
                        collapsible={true}
                        changed={set_total_service_price}
                    />
                </div>
            </div>


            <div class="ff">
                <button on:click={()=>{ 
                    extra_service_price_list.push({ description: "", rate: 0, quantity: 1, price: 0, tax_rates: convert_tax_rates([], tax_rate_options)});
                    extra_service_price_list = extra_service_price_list;
                }} style="background-color: #1769aa; color: white;" disabled={is_busy}>
                    <i class="fa-plus" style="font-style: normal;"></i> 
                    Extra Service
                </button>
                {#each extra_service_price_list as item, index}
                <div class="formrow">
                    <IFTAInput 
                        type={"textarea"}
                        label={"Description"}
                        placeholder={""}
                        maxlength={5000}
                        bind:value={item.description}
                        show_error={item.description_show_error}
                        error_text={item.description_error_text}
                        validation_function={() => description_validation_func(item)}
                    />
                    <IFTAInput 
                        type={"text"}
                        label={"Rate $"}
                        bind:value={item.rate}
                        show_error={item.rate_show_error}
                        error_text={item.rate_error_text}
                        change_function={(evt) => {
                            item.rate = evt.target.value;
                            item.price = item.rate * item.quantity;
                            set_total_service_price();
                        }}
                        validation_function={() => rate_validation_func(item)}
                    />
                    <IFTAInput 
                        type={"text"}
                        label={"Quantity"}
                        bind:value={item.quantity}
                        show_error={item.quantity_show_error}
                        error_text={item.quantity_error_text}
                        change_function={(evt) => {
                            item.quantity = evt.target.value;
                            item.price = item.rate * item.quantity;
                            set_total_service_price();
                        }}
                        validation_function={() => quantity_validation_func(item)},
                    />
                    <div class="mockgroupitem">
                        <Itemselector 
                            title="Tax Rates"
                            bind:items={item.tax_rates}
                            collapsible={true}
                            changed={set_total_service_price}
                        />
                    </div>
                    <IFTAInput 
                        type={"text"}
                        label={"Price $"}
                        bind:value={item.price}
                        disabled={true}
                    />
                    <button on:click={()=>{ 
                        extra_service_price_list.splice(index, 1); 
                        extra_service_price_list = extra_service_price_list;
                        set_total_service_price();
                    }} class="btn-icon"><i class="fas fa-trash"></i></button>
                </div>
                {/each}
                
            </div>

            <div class="ff formrow" style="width: 50%;margin-left: 50%;">
                {#each fields.filter((e)=>e.group === "pricing2") as nf}
                <IFTAInput 
                    type={(nf.type !== undefined) ? nf.type : ""}
                    label={(nf.label !== undefined) ? nf.label : ""}
                    placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""}
                    helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""}
                    select_options={(nf.select_options !== undefined) ? nf.select_options : ""}
                    name={nf.name}
                    show_error={nf.show_error}
                    error_text={nf.error_text}
                    bind:value={nf.value}
                    bind:change_function={nf.change_function}
                    bind:validation_function={nf.validation_function}
                    bind:extFuncs={nf.ext_funcs}
                    bind:hidden={nf.hidden}
                    bind:disabled={nf.disabled}
                />
                {/each}
            </div>
        </div>
    </div>

    {#if !(profile && profile.role === 'lead')}
    <div class="section crewinfo">
        <div class="sectiontitle"><i class="fal fa-user-hard-hat"></i> Crew Information</div>
        <div class="sectioninfo">
            <div class="ff formrow">
                <div class="mockgroupitem">
                    <Itemselector 
                        title="Crew Names"
                        bind:items={crew_items}
                        collapsible={true}
                        bind:error_msg={crew_selection_error_msg}
                        bind:is_crew_check_first={is_crew_check_first}
                    />
                </div>
                {#each fields.filter((e)=>e.group === "crew1") as nf}
                    <IFTAInput 
                        type={!is_employee_exists ? ((nf.type !== undefined) ? nf.type : "") : 'hidden'}
                        label={!is_employee_exists ? ((nf.label !== undefined) ? nf.label : "") : ''} 
                        placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
                        helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
                        select_options={(nf.select_options !== undefined) ? nf.select_options : ""}
                        name={nf.name}
                        show_error={nf.show_error}
                        error_text={nf.error_text}
                        bind:change_function={nf.change_function}
                        bind:value={nf.value}
                        bind:hidden={nf.hidden}
                        bind:disabled={nf.disabled}
                        bind:validation_function={nf.validation_function}
                        bind:extFuncs={nf.ext_funcs}
                    />
                    {#if nf.label === "Crew Names" && nf.value !== "-- No crew --"}
                        <i class="fas fa-eye" style="position: absolute;left: 376px;top: 45px;cursor: pointer;color: #353535;" on:click={() => {
                            window.open(`#/User_Review?uid=${fields[22].value.split('---')[1]}`, '_blank');
                        }}></i>
                    {/if}
                {/each}
            </div>
            {#if !is_employee_exists}
            <div class="ff">
                <button on:click={()=>{ 
                    extra_contractor_price_list.push({ description: "", price: 0});
                    extra_contractor_price_list = extra_contractor_price_list;
                }} style="background-color: #1769aa; color: white;" disabled={is_busy}>
                    <i class="fa-plus" style="font-style: normal;"></i> 
                    Extra Contractor Price
                </button>
                {#each extra_contractor_price_list as item, index}
                <div class="formrow">
                    <IFTAInput 
                        type={"textarea"}
                        label={"Description"}
                        placeholder={""}
                        maxlength={5000}
                        bind:value={item.description}
                        show_error={item.description_show_error}
                        error_text={item.description_error_text}
                        validation_function={() => description_validation_func(item)}
                    />
                    <IFTAInput 
                        type={"text"}
                        label={"Price $"}
                        bind:value={item.price}
                        show_error={item.price_show_error}
                        error_text={item.price_error_text}
                        change_function={(evt) => {
                            item.price = evt.target.value;
                            set_total_service_price();
                        }}
                        validation_function={() => price_validation_func(item)}
                    />
                    <button on:click={()=>{ 
                        extra_contractor_price_list.splice(index, 1); 
                        extra_contractor_price_list = extra_contractor_price_list;
                        set_total_service_price();
                    }} class="btn-icon"><i class="fas fa-trash"></i></button>
                </div>
                {/each}
                
            </div>
            {/if}
        </div>
    </div>
    {/if}

    {#if is_employee_exists}
    <div class="section timesheetinfo">
        <div class="sectiontitle"><i class="fal fa-user-hard-hat"></i> Timesheet</div>
        <div class="sectioninfo">
            <table>
                <tr>
                    <th>Crew name</th>
                    <th>Hours</th>
                    <th>Notes</th>
                </tr>
                {#each crew_items.filter(it => it.role === 'employee' && it.a) as item}
                <tr>
                    <td>{ item.t }</td>
                    <td><input type="number" bind:value={item.hours} min="0" style="width: 60px; border-radius: 4px;"></td>
                    <td><textarea rows=1 bind:value={item.notes} style="border-radius: 4px; margin-top: 6px;"></textarea></td>
                </tr>
                {/each}
            </table>
        </div>
    </div>
    {/if}

    <div class="section serviceinfo">
        <div class="sectiontitle"><i class="fas fa-info-circle"></i> Service Information</div>
        <div class="sectioninfo">
            <div class="ff formrow">
                {#each fields.filter((e)=>e.group === "service1") as nf}
                <IFTAInput 
                    type={(nf.type !== undefined) ? nf.type : ""} 
                    label={(nf.label !== undefined) ? nf.label : ""} 
                    placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
                    helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
                    select_options={(nf.select_options !== undefined) ? nf.select_options : ""}
                    name={nf.name}
                    show_error={nf.show_error}
                    error_text={nf.error_text}
                    bind:value={nf.value}
                    bind:change_function={nf.change_function}
                    bind:validation_function={nf.validation_function}
                    bind:extFuncs={nf.ext_funcs}
                />
                {/each}
            </div>

            <div class="ff formrow">
                {#each fields.filter((e)=>e.group === "service2") as nf}
                <IFTAInput 
                    type={(nf.type !== undefined) ? nf.type : ""} 
                    label={(nf.label !== undefined) ? nf.label : ""} 
                    placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
                    helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
                    select_options={(nf.select_options !== undefined) ? nf.select_options : ""}
                    name={nf.name}
                    show_error={nf.show_error}
                    error_text={nf.error_text}
                    bind:value={nf.value}
                    bind:disabled={nf.disabled}
                    bind:hidden={nf.hidden}
                    bind:validation_function={nf.validation_function}
                    bind:extFuncs={nf.ext_funcs}
                />
                {/each}
            </div>

            <div class="ff formrow">
                {#each fields.filter((e)=>e.group === "comments") as nf}
                <IFTAInput
                    type={(nf.type !== undefined) ? nf.type : ""} 
                    label={(nf.label !== undefined) ? nf.label : ""} 
                    placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
                    helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
                    select_options={(nf.select_options !== undefined) ? nf.select_options : ""}
                    name={nf.name}
                    show_error={nf.show_error}
                    error_text={nf.error_text}
                    maxlength={nf.maxlength}
                    bind:value={nf.value}
                    bind:validation_function={nf.validation_function}
                    bind:extFuncs={nf.ext_funcs}
                />
                {/each}
            </div>
        </div>
    </div>

    {#if !(profile && profile.role === 'lead')}
    <div class="section paymentinfo" style={fields[9].value === 'Credit Card' ? "" : "display: none;"}>
        <div class="sectiontitle"><i class="fas fa-money-check-alt"></i> Payment Information</div>
        <div class="creditcardentrycheckbox">
            <label>
                <input type=checkbox bind:checked={show_cc_entry}>
                Add Card Info
            </label>
        </div>
        {#if show_cc_entry}
        <div class="sectioninfo">
            <CreditCardEntry
                bind:cc_name={cc_name}
                bind:cc_number={cc_number}
                bind:cc_expiry={cc_expiry}
                bind:cc_cvc={cc_cvc}
                bind:is_cc_number_valid={is_cc_number_valid}
                bind:is_cc_cvc_valid={is_cc_cvc_valid}
                bind:is_cc_expiry_valid={is_cc_expiry_valid}
            />
        </div>
        {/if}
    </div>
    {/if}

    <div class="section photoinfo">
        <div class="sectiontitle"><i class="fas fa-info-circle"></i> Photos</div>
        <div class="sectioninfo">
            <div class="photo-list">
                {#each photos as photo, index}
                {#if !photo.deleted}
                <div class="photo-item">
                    <img class="photo" src="{photo.body}" alt="d" />
                    <button on:click={()=>{ onFileRemoved(index); }}><i class="fas fa-trash"></i> Delete</button>
                </div>
                {/if}
                {/each}
            </div>
            <div style="margin: 10px;">
                <button on:click={()=>{fileinput.click();}} style="background-color: #1769aa; color: white;" disabled={is_busy}>Add Photo</button>
                <input style="display:none" type="file" accept=".jpg, .jpeg, .png" on:change={(e)=>onFileSelected(e)} bind:this={fileinput} multiple>
            </div>

        </div>
    </div>

    <div class="section updatebuttonholder">
        <div class="updatebutton">
            <button on:click={() => { create_job_or_book('job'); }} disabled={is_busy}>
                {myself.plan_type !== 'basic' ? 'Create Job' : 'Create Request'}
            </button>
        </div>
        <div class="backbutton">
            <button on:click={()=>{ pop(); }}>
                <i class="fas fa-arrow-circle-left"></i> Back
            </button>
        </div>
        <div class="bookinglinkbutton">
            <button on:click={() => { create_job_or_book('book'); }}>
                <i class="fas fa-link"></i> Create Booking Link
            </button>
            <!-- <input type='checkbox' id='price_calculator' bind:checked={price_calculator} on:click={() => {
                fields[10].hidden = !price_calculator;
                fields[11].hidden = !price_calculator;
                fields[12].hidden = !price_calculator;
                fields[23].hidden = !price_calculator;
                fields[24].hidden = !price_calculator;
                fields[25].hidden = !price_calculator;
                fields[26].hidden = !price_calculator;
                fields[27].hidden = !price_calculator;
            }} />
            <label for="price_calculator">Price Calculator</label> -->
        </div>
    </div>
</div>

<style>
    .ff {
        padding: 10px;
        width: 100%;
    }
    :global(.ff .group) {
        margin-left: 5px;
        margin-right: 5px;
    }
    .formrow {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        padding: 0px;
    }
    .sectioninfo {
        width: 100%;
    }
    .mockgroupitem {
        width: 100%;
        border: solid 1px #ccc;
        border-radius:6px;
        padding-top: 15px;
        background-color: white;
        margin-bottom: 15px;
    }
    .contentholder {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(12, 1fr);
        grid-template-rows: auto;
        grid-template-areas: "ci ci ci ci ci ci ci ci ci ci ci ci"
                             "si si si si si si si si si si si si"
                             "pi pi pi pi pi pi pi pi pi pi pi pi"
                             "cr cr cr cr cr cr cr cr cr cr cr cr"
                             "ts ts ts ts ts ts ts ts ts ts ts ts"
                             "ph ph ph ph ph ph ph ph ph ph ph ph"
                             "py py py py py py py py py py py py"
                             "ub ub ub ub ub ub ub ub ub ub ub ub";
    }
    .contactinfo {
        grid-area: ci;
    }
    .pricinginfo {
        grid-area: pi;
    }
    .serviceinfo {
        grid-area: si;
    }
    .paymentinfo {
        grid-area: ph;
    }
    .crewinfo {
        grid-area: cr;
    }
    .timesheetinfo {
        grid-area: ts;
    }
    .photoinfo {
        grid-area: py;
    }
    .updatebuttonholder {
        grid-area: ub;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
    }
    .updatebuttonholder button {
        width: 200px;
        margin-right: 10px;
    }
    .updatebutton button {
        background-color: #357a38;
        color: white;
    }
    .backbutton button {
        background-color: #ff9100;
        color: white;
    }
    .bookinglinkbutton button {
        background-color: #1769aa;
        color: white;
    }
    .creditcardentrycheckbox label {
        font-weight: bold;
    }
    .section {
        background-color: #ccc;
        margin: 10px 0px;
    }
    .photo-list {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }
    .photo-item {
        display: flex;
        flex-direction: column;
        margin: 10px;
    }
	.photo{
		height: 100px;
		width: 100px;
	}
    @media (max-device-width: 1024px), (max-width: 1023px) {
        .ff {
            padding: 10px;
            width: 100%;
        }
        .formrow {
            width: 100%;
            padding: 0px;
            display: flex;
            flex-direction: column;
        }
        .contentholder {
            width: 100%;
            max-width: 100vw;
            margin-left: auto;
            margin-right: auto;
            display: grid;
            grid-template-columns: repeat(1, 1fr);
            grid-template-rows: auto;
            grid-template-areas: "ci"
                                 "si"
                                 "pi"
                                 "cr"
                                 "ts"
                                 "ph"
                                 "py"
                                 "ub";
        }
        .updatebuttonholder {
            grid-area: ub;
            width: 100%;
            display: flex;
            flex-direction: column;
            
        }
        .updatebuttonholder button {
            width: 100%;
            margin-right: 10px;
        }
        .updatebutton button {
            background-color: #357a38;
            color: white;
        }
        .backbutton button {
            background-color: #ff9100;
            color: white;
        }
        .bookinglinkbutton button {
            background-color: #1769aa;
            color: white;
        }
    }
    .ff {
        padding: 10px;
        width: 100%;
    }
    :global(.ff .group) {
        padding: 0px;
    }
    .formrow {
        width: 100%;
        padding: 0px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
    @media (max-device-width: 1024px), (max-width: 1023px) {
        .ff {
            padding: 0px;
            width: 100%;
        }
        .formrow {
            width: 100%;
            padding: 0px;
            display: flex;
            flex-direction: column;
        }
    }
</style>